module.exports = __webpack_public_path__ + "img/royal hospitals indoor shoot-2.4d11ad11.webp";